import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ClinicalTrainingEventsState } from './types';
import { ClinicalTrainingEventsMutations } from './types';
import ClinicalTrainingEvent from './clinical-training-event';
import { ListStatus, EditableStatus } from '@/store/types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const state: ClinicalTrainingEventsState = {
  list: [],
  listStatus: ListStatus.Initial,
  listPagination: {
    currentPage: 1,
    lastPage: 1,
    total: 0,
  },
  editable: null,
  initialEditable: null,
  editableStatus: EditableStatus.Loading,
  products: [],
};

const clinicalTrainingEvents: Module<ClinicalTrainingEventsState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default clinicalTrainingEvents;
